import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable import/no-commonjs */
import pathToRegexp, { compile } from 'path-to-regexp';
import * as NavigationActions from '../NavigationActions';
import invariant from '../utils/invariant';

var queryString = require('query-string');

export var getParamsFromPath = function getParamsFromPath(inputParams, pathMatch, pathMatchKeys) {
  var params = pathMatch.slice(1).reduce( // iterate over matched path params
  function (paramsOut, matchResult, i) {
    var key = pathMatchKeys[i];

    if (!key || key.asterisk) {
      return paramsOut;
    }

    var paramName = key.name;
    var decodedMatchResult;

    if (matchResult) {
      try {
        decodedMatchResult = decodeURIComponent(matchResult);
      } catch (e) {// ignore `URIError: malformed URI`
      }
    }

    paramsOut[paramName] = decodedMatchResult || matchResult;
    return paramsOut;
  }, _objectSpread({}, inputParams));
  return params;
};

var getRestOfPath = function getRestOfPath(pathMatch, pathMatchKeys) {
  var rest = pathMatch[pathMatchKeys.findIndex(function (k) {
    return k.asterisk;
  }) + 1];
  return rest;
};

var determineDelimiter = function determineDelimiter(uri, uriPrefix) {
  if (Array.isArray(uriPrefix)) {
    if (uriPrefix.length === 1) return uriPrefix[0];

    var _iterator = _createForOfIteratorHelper(uriPrefix),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prefix = _step.value;
        if (uri.startsWith(prefix)) return prefix;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  }

  return uriPrefix;
};

export var urlToPathAndParams = function urlToPathAndParams(url, uriPrefix) {
  var searchMatch = url.match(/^(.*)\?(.*)$/);

  var _ref = searchMatch || [null, url, {}],
      _ref2 = _slicedToArray(_ref, 3),
      urlWithoutQuery = _ref2[1],
      query = _ref2[2];

  var params = queryString.parse(query);
  var delimiter = determineDelimiter(urlWithoutQuery, uriPrefix) || '://';
  var path = urlWithoutQuery.split(delimiter)[1];

  if (path === undefined) {
    path = urlWithoutQuery;
  }

  if (path === '/') {
    path = '';
  }

  if (path[path.length - 1] === '/') {
    path = path.slice(0, -1);
  }

  return {
    path: path,
    params: params
  };
};
export var createPathParser = function createPathParser(childRouters, routeConfigs, _ref3) {
  var _ref3$paths = _ref3.paths,
      pathConfigs = _ref3$paths === void 0 ? {} : _ref3$paths,
      disableRouteNamePaths = _ref3.disableRouteNamePaths;
  var pathsByRouteNames = {};
  var paths = []; // Build pathsByRouteNames, which includes a regex to match paths for each route. Keep in mind, the regex will pass for the route and all child routes. The code that uses pathsByRouteNames will need to also verify that the child router produces an action, in the case of isPathMatchable false (a null path).

  Object.keys(childRouters).forEach(function (routeName) {
    var pathPattern; // First check for paths on the router, then check the route config

    if (pathConfigs[routeName] !== undefined) {
      pathPattern = pathConfigs[routeName];
    } else {
      pathPattern = routeConfigs[routeName].path;
    }

    if (pathPattern === undefined) {
      // If the user hasn't specified a path at all nor disableRouteNamePaths, then we assume the routeName is an appropriate path
      pathPattern = disableRouteNamePaths ? null : routeName;
    }

    invariant(pathPattern === null || typeof pathPattern === 'string', "Route path for ".concat(routeName, " must be specified as a string, or null.")); // the path may be specified as null, which is similar to empty string because it allows child routers to handle the action, but it will not match empty paths

    var isPathMatchable = pathPattern !== null; // pathPattern is a string with inline params, such as people/:id/*foo

    var exactReKeys = [];
    var exactRe = isPathMatchable ? pathToRegexp(pathPattern, exactReKeys) : null;
    var extendedPathReKeys = [];
    var isWildcard = pathPattern === '' || !isPathMatchable;
    var extendedPathRe = pathToRegexp(isWildcard ? '*' : "".concat(pathPattern, "/*"), extendedPathReKeys);
    pathsByRouteNames[routeName] = {
      exactRe: exactRe,
      exactReKeys: exactReKeys,
      extendedPathRe: extendedPathRe,
      extendedPathReKeys: extendedPathReKeys,
      isWildcard: isWildcard,
      toPath: pathPattern === null ? function () {
        return '';
      } : compile(pathPattern)
    };
  });
  paths = Object.entries(pathsByRouteNames);

  var getActionForPathAndParams = function getActionForPathAndParams() {
    var pathToResolve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var inputParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Attempt to match `pathToResolve` with a route in this router's routeConfigs, deferring to child routers
    var _iterator2 = _createForOfIteratorHelper(paths),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
            routeName = _step2$value[0],
            path = _step2$value[1];

        var exactRe = path.exactRe,
            exactReKeys = path.exactReKeys,
            extendedPathRe = path.extendedPathRe,
            extendedPathReKeys = path.extendedPathReKeys;
        var childRouter = childRouters[routeName];
        var exactMatch = exactRe && exactRe.exec(pathToResolve);

        if (exactMatch && exactMatch.length) {
          var extendedMatch = extendedPathRe && extendedPathRe.exec(pathToResolve);
          var childAction = null;

          if (extendedMatch && childRouter) {
            var restOfPath = getRestOfPath(extendedMatch, extendedPathReKeys);
            childAction = childRouter.getActionForPathAndParams(restOfPath, inputParams);
          }

          return NavigationActions.navigate({
            routeName: routeName,
            params: getParamsFromPath(inputParams, exactMatch, exactReKeys),
            action: childAction
          });
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var _iterator3 = _createForOfIteratorHelper(paths),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
            _routeName = _step3$value[0],
            _path = _step3$value[1];

        var _extendedPathRe = _path.extendedPathRe,
            _extendedPathReKeys = _path.extendedPathReKeys;
        var _childRouter = childRouters[_routeName];

        var _extendedMatch = _extendedPathRe && _extendedPathRe.exec(pathToResolve);

        if (_extendedMatch && _extendedMatch.length) {
          var _restOfPath = getRestOfPath(_extendedMatch, _extendedPathReKeys);

          var _childAction = null;

          if (_childRouter) {
            _childAction = _childRouter.getActionForPathAndParams(_restOfPath, inputParams);
          }

          if (!_childAction) {
            continue;
          }

          return NavigationActions.navigate({
            routeName: _routeName,
            params: getParamsFromPath(inputParams, _extendedMatch, _extendedPathReKeys),
            action: _childAction
          });
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return null;
  };

  var getPathAndParamsForRoute = function getPathAndParamsForRoute(route) {
    var routeName = route.routeName,
        params = route.params;
    var childRouter = childRouters[routeName];
    var _pathsByRouteNames$ro = pathsByRouteNames[routeName],
        toPath = _pathsByRouteNames$ro.toPath,
        exactReKeys = _pathsByRouteNames$ro.exactReKeys;
    var subPath = toPath(params);
    var nonPathParams = {};

    if (params) {
      Object.keys(params).filter(function (paramName) {
        return !exactReKeys.find(function (k) {
          return k.name === paramName;
        });
      }).forEach(function (paramName) {
        nonPathParams[paramName] = params[paramName];
      });
    }

    if (childRouter) {
      // If it has a router it's a navigator.
      // If it doesn't have router it's an ordinary React component.
      var child = childRouter.getPathAndParamsForState(route);
      return {
        path: subPath ? "".concat(subPath, "/").concat(child.path) : child.path,
        params: child.params ? _objectSpread(_objectSpread({}, nonPathParams), child.params) : nonPathParams
      };
    }

    return {
      path: subPath,
      params: nonPathParams
    };
  };

  return {
    getActionForPathAndParams: getActionForPathAndParams,
    getPathAndParamsForRoute: getPathAndParamsForRoute
  };
};